export default function accordion() {
   var acc = document.getElementsByClassName("accordion");
   var i;

   for (i = 0; i < acc.length; i++) {
       acc[i].addEventListener("click", function () {
           this.classList.toggle("active");

           [].forEach.call(acc, function (el) {
               if (el !== this) {
                   el.classList.remove("active");
               }
           }, this);

       });
   }
}